/*rutas dashboard*/
export default [
	{
    path: '/Display',
    name: 'Display',
    view: 'DisplayDash',
    folder: 'views/Display',
    meta: {requiresAuth: true},
  }
];